import {
    boolean,
    snakeCase,
    text,
    timestamp,
    varchar,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'

export const clientsTable = snakeCase.table('clients', {
    id: id('cli'),
    restauthOrganizationId: varchar({ length: 255 }).notNull().unique(),
    name: varchar({ length: 255 }).notNull(),
    contactEmail: varchar({ length: 255 }).notNull(),
    contactPhone: varchar({ length: 30 }),
    logoUrl: text(),
    isActivateBlockList: boolean().default(false),
    activatedAt: timestamp({ withTimezone: true }).defaultNow(),
    suspendedAt: timestamp({ withTimezone: true }),
    lastLoginAt: timestamp({ withTimezone: true }),
    ...timestamps,
})
